<template>
  <WbsRechner></WbsRechner>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import WbsRechner from './components/WbsRechner.vue';

@Options({
  components: {
    WbsRechner,
  },
})
export default class App extends Vue {}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
